export enum ShaderName {
	VERTEX = 'vertex',
	FRAGMENT = 'fragment',
	LEAVES_FROM_NODES_SHADER = 'leaves_from_nodes_shader',
	PARTICLES_0 = 'particles_0',
	PARTICLES_1 = 'particles_1',
	PARTICLES_2 = 'particles_2',
	PARTICLES_3 = 'particles_3',
	PARTICLES_4 = 'particles_4',
	PARTICLES_5 = 'particles_5',
	PARTICLES_6 = 'particles_6',
	PARTICLES_7 = 'particles_7',
	PARTICLES_8 = 'particles_8',
	PARTICLES_9 = 'particles_9',
}
export const ParticleShaderNames: Array<ShaderName> = [
	ShaderName.PARTICLES_0,
	ShaderName.PARTICLES_1,
	ShaderName.PARTICLES_2,
	ShaderName.PARTICLES_3,
	ShaderName.PARTICLES_4,
	ShaderName.PARTICLES_5,
	ShaderName.PARTICLES_6,
	ShaderName.PARTICLES_7,
	ShaderName.PARTICLES_8,
	ShaderName.PARTICLES_9,
];
